import * as types from '../constants/ActionTypes';

export const toggleMobileMenu = visibility => ({
  type: types.TOGGLE_MOBILE_MENU,
  payload: visibility
});
